<template>
    <div class="drop-zone" :class="{'row': !isFloat}">
        <label v-if="label && !isFloat" class="col-sm-4 field-label">{{label}}<span class="drop-zone__mandatory"
                                                                                    v-if="mandatory">*</span></label>
        <div class="form-group" :class="{'col-sm-8': !isFloat, 'form-group--centered': isCentered }">
            <label v-if="isFloat && label">{{ label }}<span class="base__mandatory" v-if="mandatory">*</span></label>
            <vue-dropzone ref="dropzone" :id="id" :options="config" @vdropzone-files-added="fileAdded"
                          @vdropzone-removed-file="fileRemoved"></vue-dropzone>
        </div>
    </div>
</template>

<script>
    import VueDropZone from "vue2-dropzone"
    import i18n from '@/languages';
    import formElementMixin from '@/components/mixins/FormElementMixin'

    export default {
        mixins: [formElementMixin],
        components: {
            'vue-dropzone': VueDropZone
        },
        props: {
            isFloat: {default: true},
            maxFiles: {
                type: Number,
                default: null
            }
        },
        async mounted() {
            const { name, ext: type, id} = this.displayValue
            if(id){
                let response = await Api.download(id, true)
                const blob = new Blob([response], {type:`image/${type}`})
                blob.name=name
                this.$refs.dropzone.addFile(blob);
            }


        },
        data: () => ({
            config: {
                url: Api.getURL(),
                method: 'post',
                withCredentials: true,
                addRemoveLinks: true,
                autoProcessQueue: false,
                dictDefaultMessage: i18n.t('LBL_DROP_FILE_TO_UPLOAD'),
                dictFileTooBig: i18n.t('LBL_FILE_SIZE_EXCEEDED'),
                dictMaxFilesExceeded: i18n.t('LBL_MAX_FILES_EXCEEDED'),
            },
        }),

        methods: {
            fileAdded(files) {
                // fixing dropzone drag & drop bug (a bit delay is required)
                setTimeout(() => {
                    this.$emit('changed', this.getFiles())
                    this.validate()
                }, 100)
            },
            fileRemoved(file, error, xhr) {
                this.$emit('changed', this.getFiles())
                this.validate()
            },

            validate() {
                this.$emit('validationCompleted', this.hasValidationError())
            },

            hasValidationError() {
                return this.$refs.dropzone.getRejectedFiles().length > 0
            },

            getFiles() {
                return this.$refs.dropzone.getAcceptedFiles()
            },

            clear() {
                this.$refs.dropzone.removeAllFiles()
            }
        },

        created() {
            this.config.maxFiles = this.maxFiles ? Math.min(this.maxFiles, this.$store.getters.getStructure.file_constraints.max_file_uploads) : this.$store.getters.getStructure.file_constraints.max_file_uploads
            this.config.maxFilesize = this.$store.getters.getStructure.file_constraints.upload_max_filesize
            this.config.acceptedFiles = (this.type == 'picture' ? this.$store.getters.getStructure.file_constraints.picture_accepted_format.map(el => '.' + el).join(',') : null)
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/components/form_elements/_dropzone.scss";</style>